export const START_JOURNEY_FORM_NAME = 'startJourney'
export const START_JOURNEY_FORM_FIELDS = ['commitNotificationTime', 'committedNotificationTime', 'timezone']
